import React, { useState } from 'react';
import { observer } from 'mobx-react';
import Modal from 'react-modal';
import { ThemedButton } from './themed/themed-button/ThemedButton';
import { TextDefault, TextLead } from './design-system/texts';
import { Heading1 } from './design-system/headings';
import { SpaceBetweenDiv, FlexDiv } from './design-system/containers';



import styled from 'styled-components';

const ImageAsLink = styled.img`
    cursor: pointer;
`;

const StyledConfirmationModal = styled(Modal)`
    inset: auto;
    padding: 24px 0;
    width: 672px;
    background-color: white;
    border-radius: 4px;
    max-height: 70vh;
`;

export const ConfirmationModal = observer(
    ({
        confirmationRequired,
        confirmationDescription,
        confirmationAction,
        confirmationTitle,
        confirmationShowCancel,
        confirmationCancelText = 'Cancel',
        additionalCheckbox,
        isConfirmationDelete,
        cancelConfirm,
        doConfirm,
    }) => {
        const [additionalCheckboxChecked, setAdditionalCheckboxChecked] =
            useState(false);

        const handleClose = () => {
            cancelConfirm();
        };

        const onConfirm = async (arg) => {
            if (!additionalCheckbox || additionalCheckboxChecked)
                return doConfirm(arg);
        };

        const renderAction = (confirmationAction) => {
            if (Array.isArray(confirmationAction)) {
                return confirmationAction.map((action) => {
                    return (
                        <ThemedButton
                            mode={!isConfirmationDelete ? 'primary' : 'red'}
                            key={action.key}
                            onClick={() => onConfirm(action.key)}
                            text={action.value}
                        ></ThemedButton>
                    );
                });
            } else {
                return (
                    <ThemedButton
                        mode={!isConfirmationDelete ? 'primary' : 'red'}
                        onClick={onConfirm}
                        text={confirmationAction}
                    ></ThemedButton>
                );
            }
        };

        const toggleAdditionalCheckboxChecked = () => {
            setAdditionalCheckboxChecked(!additionalCheckboxChecked);
        };

        return confirmationRequired ? (
            <StyledConfirmationModal isOpen={true} onRequestClose={handleClose}>
                <SpaceBetweenDiv maxHeight={88} px={48} py={24}>
                    <Heading1>{confirmationTitle}</Heading1>
                    <ImageAsLink
                        src="/static/img/close.svg"
                        alt="Close"
                        onClick={handleClose}
                    />
                </SpaceBetweenDiv>
                <FlexDiv column py={8} px={48} overflowYauto>
                    <TextLead>{confirmationDescription}</TextLead>
                    {additionalCheckbox && (
                        <label htmlFor={'additionalCheckbox'}>
                            <input
                                type="checkbox"
                                className="checkmark"
                                autoComplete={false}
                                id={'additionalCheckbox'}
                                checked={additionalCheckboxChecked}
                                onChange={toggleAdditionalCheckboxChecked}
                            />
                            {additionalCheckbox}
                            <span className="checkmark"></span>
                        </label>
                    )}
                </FlexDiv>
                <FlexDiv justifyEnd maxHeight={96} px={48} py={24} alignCenter>
                    {confirmationShowCancel && (
                        <FlexDiv pr={40}>
                            <TextDefault
                                uppercase
                                extraBold
                                link
                                onClick={handleClose}
                            >
                                {confirmationCancelText}
                            </TextDefault>
                        </FlexDiv>
                    )}
                    {renderAction(confirmationAction)}{' '}
                </FlexDiv>
            </StyledConfirmationModal>
        ) : null;
    }
);
